<template>
  <div
    :class="{
      'border-l-4 border-cyan-200 bg-cyan-50': item.overrideable,
      'border-gray-200': !item.overrideable,
      'hidden md:block': item.status === 'Complete',
    }"
    class="border-b">
    <div class="px-4 py-4 sm:px-6">
      <div class="flex">
        <div class="mr-4 flex-shrink-0">
          <div class="h-16 w-16 overflow-hidden">
            <img :src="$route('product.image', item.sku)" class="pointer-events-none object-cover" alt />
          </div>
        </div>
        <div class="flex-grow">
          <div class="sm:flex sm:items-center sm:justify-between">
            <p class="font-medium text-primary-600 md:truncate">{{ item.title }}</p>
            <div class="mt-2 flex flex-shrink-0 md:ml-2">
              <p :class="[item.status === 'Complete' ? 'border-success bg-success-100 text-success-800' : 'border-warning bg-warning-100 text-warning-800']" class="inline-flex rounded-md border px-2 text-sm font-semibold leading-5">{{ item.status }}</p>
            </div>
          </div>
          <div class="mt-2 sm:flex sm:justify-between">
            <div class="sm:flex">
              <p class="flex items-center text-sm text-gray-500">
                <HashtagIcon class="mr-1 h-4 w-4 flex-shrink-0 text-gray-400" aria-hidden="true" />
                {{ item.sku }}
              </p>
            </div>
            <div class="mt-2 inline-flex items-center rounded-md border border-info bg-primary-100 px-3 py-2 text-xl font-semibold leading-5 text-info-800 sm:mt-0">
              <p> {{ item.completed_count }} of {{ item.quantity }} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { HashtagIcon } from "@heroicons/vue/20/solid";

const { item } = defineProps({
  item: {
    type: Object,
    required: true,
  },
});
</script>
